var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimpleButton',{style:({ margin: '4px' }),attrs:{"to":{
      path: ("violationtabs/" + _vm.detail + "/violationDetails#tab"),
      params: {
        id: _vm.detail
      }
    }}},[_vm._v(" Details ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }